import Swal, { SweetAlertIcon } from "sweetalert2";

/**
 * Generic reusable confirmation dialog.
 *
 * @param title - The main title text of the alert.
 * @param text - Optional description text.
 * @param icon - SweetAlert icon type: "warning", "error", "success", "info", "question".
 * @param confirmButtonText - Text for the confirm button (default: "Yes, proceed").
 * @param cancelButtonText - Text for the cancel button (default: "Cancel").
 * @returns Promise<boolean> - Resolves to true if confirmed, false otherwise.
 */
export const showConfirmation = async (
  title: string,
  text: string = "This action cannot be undone.",
  icon: SweetAlertIcon = "warning",
  confirmButtonText: string = "Yes, proceed",
  cancelButtonText: string = "Cancel"
): Promise<boolean> => {
  const result = await Swal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText,
    cancelButtonText,
  });

  return result.isConfirmed;
};

/**
 * Generic reusable alert (info/error/success) popup.
 *
 * @param title - Alert title.
 * @param text - Alert description.
 * @param icon - Alert type.
 */
export const showAlert = (
  title: string,
  text: string,
  icon: SweetAlertIcon = "info"
): void => {
  Swal.fire({
    title,
    text,
    icon,
    confirmButtonColor: "#3085d6",
  });
};
